import {
  setMessageVisibility,
  getFormValue,
} from 'app/services/businessFunctionHelpers';
import { MessagesEnum, FormsEnum, FieldsEnum } from 'app/shared/enums';
import { checkIsDataObfuscated } from '../helpers/checkIsDataObfuscated';

export const obfuscation = {
  showTravelCalculationEmailObfuscatedMessage(initialRun?: boolean) {
    const email = getFormValue(
      FieldsEnum.TravelEmailAddress,
      FormsEnum.TravelForm
    );

    const showObfuscatedMessage = checkIsDataObfuscated(email, initialRun);

    setMessageVisibility({
      key: MessagesEnum.TravelInsurantEmailObfuscated,
      visible: showObfuscatedMessage,
      formName: FormsEnum.TravelForm,
    });
  },
};
